import { handleApiError } from '../../utils/errorHandlerUtils';

const API_URL = process.env.REACT_APP_API_URL;

export function getFullUrl(url) {
    return `${API_URL}${url}`;
}

export async function apiFetch(url, options = {}) {
    const fullUrl = url.startsWith(API_URL)
        ? url
        : getFullUrl(url);
    const response = await fetch(fullUrl, {
        credentials: "include",
        ...options
    });

    if (response.status === 401) {
        if (window.location.pathname !== '/auth') {
            window.location.href = '/auth';
            return;
        } else {
            const error = await response.json();
            throw error;
        }
    }

    if (!response.ok) {
        const error = await handleApiError(response);
        error.status = response.status; // добавляем статус для совместимости
        throw error;
    }

    let data;
    const responseType = options.responseType || 'json';

    if (response.status !== 204) {
        if (responseType === 'blob') {
            data = await response.blob();
        } else if (responseType === 'arrayBuffer') {
            data = await response.arrayBuffer();
        } else if (responseType === 'text') {
            data = await response.text();
        } else {
            data = await response.json();
        }
    }

    return data;
}

export function get(url, options = {}) {
    return apiFetch(url, {
        method: "GET",
        ...options
    });
}

export function getText(url, options = {}) {
    return apiFetch(url, {
        method: "GET",
        responseType: 'text',
        ...options
    });
}

export function getBlob(url, options = {}) {
    return apiFetch(url, {
        method: "GET",
        responseType: 'blob',
        ...options
    });
}

export function getArrayBuffer(url, options = {}) {
    return apiFetch(url, {
        method: "GET",
        responseType: 'arrayBuffer',
        ...options
    });
}

export function post(url, body, options = {}) {
    const fetchOptions = {
        method: "POST",
        ...options,
    };

    if (body instanceof FormData) {
        fetchOptions.body = body;
        if (fetchOptions.headers) {
            delete fetchOptions.headers['Content-Type'];
        }
    } else {
        fetchOptions.headers = {
            "Content-Type": "application/json",
            ...(options.headers || {}),
        };
        fetchOptions.body = JSON.stringify(body);
    }

    return apiFetch(url, fetchOptions);
}

export function postText(url, body, options = {}) {
    const fetchOptions = {
        method: "POST",
        responseType: 'text',
        ...options,
    };

    if (body instanceof FormData) {
        fetchOptions.body = body;
        if (fetchOptions.headers) {
            delete fetchOptions.headers['Content-Type'];
        }
    } else {
        fetchOptions.headers = {
            "Content-Type": "application/json",
            ...(options.headers || {}),
        };
        fetchOptions.body = JSON.stringify(body);
    }

    return apiFetch(url, fetchOptions);
}

export function postBlob(url, body, options = {}) {
    const fetchOptions = {
        method: "POST",
        responseType: 'blob',
        ...options,
    };

    if (body instanceof FormData) {
        fetchOptions.body = body;
        if (fetchOptions.headers) {
            delete fetchOptions.headers['Content-Type'];
        }
    } else {
        fetchOptions.headers = {
            "Content-Type": "application/json",
            ...(options.headers || {}),
        };
        fetchOptions.body = JSON.stringify(body);
    }

    return apiFetch(url, fetchOptions);
}

export function put(url, body) {
    return apiFetch(url, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
}

export function del(url) {
    return apiFetch(url, {
        method: "DELETE"
    });
}